import { api } from './index';
function create(subscription) { const path = '/api/internal/subscriptions'; return api({ method: 'post', url: path, data: { subscription } }).then(response => response.data); }
export { create };
